import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceForReceiptQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String'];
}>;


export type InvoiceForReceiptQuery = { readonly __typename?: 'Query', readonly invoice?: { readonly __typename?: 'Invoice', readonly _id: string, readonly invoiceNumber: string, readonly patientType: Types.PatientType, readonly created: string, readonly invoiceStatus: Types.InvoiceStatus, readonly patient: { readonly __typename?: 'InvoicePatient', readonly cardId?: string | null, readonly passport?: { readonly __typename?: 'InvoicePatientPassport', readonly uid?: string | null } | null, readonly person?: { readonly __typename?: 'InvoicePerson', readonly dob: string, readonly name: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null } } | null, readonly insurance?: { readonly __typename?: 'InvoicePatientInsurance', readonly insuranceType: string, readonly insuranceDetails?: unknown | null } | null }, readonly createdBy: { readonly __typename?: 'InvoiceUser', readonly uuid?: string | null, readonly person?: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly facility: { readonly __typename?: 'InvoiceClinic', readonly name: string, readonly addresses?: ReadonlyArray<{ readonly __typename?: 'Address', readonly ward?: string | null, readonly street?: string | null, readonly subCounty?: string | null, readonly state?: string | null } | null> | null }, readonly inpatientDetails?: { readonly __typename?: 'InpatientDetails', readonly inpatientNumber?: string | null, readonly admission?: string | null, readonly discharge?: string | null, readonly ward?: string | null, readonly dailyRebateAmount?: number | null } | null, readonly balance: { readonly __typename?: 'Balance', readonly paid?: number | null, readonly total?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null }, readonly lineItems: ReadonlyArray<{ readonly __typename?: 'InvoiceLineItem', readonly id?: string | null, readonly quantity: number, readonly cost: number, readonly disabled: boolean, readonly priceListItem: { readonly __typename?: 'PriceListItem', readonly name: string, readonly priceListItemType: Types.PriceListItemType } }>, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly type: Types.PayerType, readonly name: string, readonly balance: { readonly __typename?: 'Balance', readonly paid?: number | null, readonly total?: number | null }, readonly insuranceDetails?: { readonly __typename?: 'InsuranceDetails', readonly name?: string | null, readonly insuranceNumber?: string | null, readonly dependent?: Types.Dependent | null } | null }>, readonly transactions: ReadonlyArray<{ readonly __typename?: 'Transaction', readonly payer?: { readonly __typename?: 'Payer', readonly type: Types.PayerType } | null, readonly payment?: { readonly __typename?: 'PaymentDetails', readonly paymentMethod: Types.PaymentMethod, readonly authCode?: string | null } | null, readonly refund?: { readonly __typename?: 'RefundDetails', readonly paymentMethod: Types.PaymentMethod, readonly authCode?: string | null } | null, readonly amount?: { readonly __typename?: 'Amount', readonly value: number } | null, readonly currencyExchange?: { readonly __typename?: 'CurrencyExchange', readonly from: { readonly __typename?: 'Amount', readonly currency: Types.BillingCurrency, readonly value: number }, readonly to: { readonly __typename?: 'Amount', readonly currency: Types.BillingCurrency, readonly value: number }, readonly exchangeRate: { readonly __typename?: 'CurrencyExchangeRate', readonly id: string, readonly baseCurrency: Types.BillingCurrency, readonly quoteCurrency: Types.BillingCurrency, readonly rate: string, readonly effectiveDate: string } } | null, readonly actionedBy?: { readonly __typename?: 'InvoiceUser', readonly person?: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null }> } | null };


export const InvoiceForReceiptDocument = gql`
    query invoiceForReceipt($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    invoiceNumber
    patientType
    patient {
      cardId
      passport {
        uid
      }
      person {
        name {
          firstname
          middlename
          lastname
        }
        dob
      }
      insurance {
        insuranceType
        insuranceDetails
      }
    }
    created
    createdBy {
      person {
        firstname
        lastname
      }
      uuid
    }
    facility {
      name
      addresses {
        ward
        street
        subCounty
        state
      }
    }
    inpatientDetails {
      inpatientNumber
      admission
      discharge
      ward
      dailyRebateAmount
    }
    invoiceStatus
    balance {
      paid
      total
      due
      currency
    }
    lineItems {
      id
      priceListItem {
        name
        priceListItemType
      }
      quantity
      cost
      disabled
    }
    payers {
      type
      name
      balance {
        paid
        total
      }
      insuranceDetails {
        name
        insuranceNumber
        dependent
      }
    }
    transactions {
      payer {
        type
      }
      payment {
        paymentMethod
        authCode
      }
      refund {
        paymentMethod
        authCode
      }
      amount {
        value
      }
      currencyExchange {
        from {
          currency
          value
        }
        to {
          currency
          value
        }
        exchangeRate {
          id
          baseCurrency
          quoteCurrency
          rate
          effectiveDate
        }
      }
      actionedBy {
        person {
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useInvoiceForReceiptQuery__
 *
 * To run a query within a React component, call `useInvoiceForReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceForReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceForReceiptQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceForReceiptQuery(baseOptions: Apollo.QueryHookOptions<InvoiceForReceiptQuery, InvoiceForReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceForReceiptQuery, InvoiceForReceiptQueryVariables>(InvoiceForReceiptDocument, options);
      }
export function useInvoiceForReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceForReceiptQuery, InvoiceForReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceForReceiptQuery, InvoiceForReceiptQueryVariables>(InvoiceForReceiptDocument, options);
        }
export type InvoiceForReceiptQueryHookResult = ReturnType<typeof useInvoiceForReceiptQuery>;
export type InvoiceForReceiptLazyQueryHookResult = ReturnType<typeof useInvoiceForReceiptLazyQuery>;
export type InvoiceForReceiptQueryResult = Apollo.QueryResult<InvoiceForReceiptQuery, InvoiceForReceiptQueryVariables>;